/** @format */

export enum ImageFormat {
  JPEG = 'jpeg',
  PJPEG = 'pjpeg',
  WEBP = 'webp',
}
